<template>
    <div id="manualBillingReport">
      <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <div id="page-content-wrapper" class="admin-content-area" >
        <template v-if="cantAccessPage === true">
          <div class="page-name">
            <div class="page-title">Manual Billing Invoice</div>
            <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                          <i class="fp-export"></i> Export
                      </a>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content contact-list">
              <data-table-filter-config :moduleName="'manualBillingReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
              <div class="data-table bg-white overflow-hidden">
                  <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                  <section class="bg-white data-table">
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'manualBillingReport'" :position="'top'">
                    </custom-pagination>
                    <vue-good-table
                      mode="remote"
                      title="Manual Billing Report"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :paginationOptions="{
                          enabled: false,
                          position: 'both',
                          perPage: perPage,
                          dropdownAllowAll: false,
                          setCurrentPage:listCurrentPage,
                          perPageDropdown:dropDownPerPage,
                      }"
                      :search-options="{
                      enabled: false,
                      }"
  
                      >
                    </vue-good-table>
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange">
                    </custom-pagination>
                  </section>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
          </div>
        </template>
        <template v-else>
          <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  
  
  
  
  
  
  
   import {commonMixins} from '../../mixins/commonMixins';
   import {dataTableMixins} from '../../mixins/dataTableMixins';
  export default {
    name: "ManualBillingReport",
    metaInfo() {
              return {title: "Manual Billing Report | " +process.env.COPYRIGHT_NAME}
          },
    mixins: [commonMixins,dataTableMixins],
    data: () => ({
      firstLoad: 0,
      cantAccessPage:"",
      loading: false,
      action:'list',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
        {
            label: 'Charge Date',
            field: 'misc_charge_date',
            fpFieldType:"date",
            filterable: true,
            hidden:false,
            width:'90px',
        },
        {
            label: "Charge Nbr",
            field: "charge_seq",
            hidden:false,
            fpFieldType:"text",
            filterable: true,
        },
        {
            label: 'Facility',
            field: 'facility',
            hidden:false,
            fpFieldType:"text",
            filterable: true,
        },
        {
            label: 'Charge Description',
            field: 'misc_comment',
            fpFieldType:"text",
            type:'text',
            filterable: true,
            hidden:false,
            width:'90px',
        },
        {
            label: 'Customer Number',
            field: 'custNumber',
            fpFieldType:"text",
            type:'text',
            filterable: true,
            hidden:false,
            width:'90px',
        },{
            label: 'Customer Name',
            field: 'custName',
            fpFieldType:"text",
            type:'text',
            filterable: true,
            hidden:false,
            width:'90px',
        },
        {
            label: 'Invoice',
            field: 'invoice_number',
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: 'Amount',
            field: 'invoice_amount',
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            width:'90px',
        },
        {
            label: 'Charge Code',
            field: 'charge_name',
            fpFieldType:"text",
            hidden: false,
            filterable: true,
        },
        {
            label: 'Unit',
            field: 'l_unit_no',
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            width:'90px',
        },
        {
            label: 'GL Account',
            field: 'gl_account_code',
            hidden:false,
            filterable: true,
            fpFieldType:"text",
        },
        {
            label: 'Account Description',
            field: 'gl_account_description',
            hidden:false,
            filterable: true,
            fpFieldType:"text",
        },
        {
            label: 'Line Facility',
            field: 'facility',
            hidden:false,
            fpFieldType:"text",
            filterable: true,
        },
        {
            label: 'Reason Code',
            field: 'reason_code',
            hidden:false,
            filterable: true,
            fpFieldType:"text",
        },
        {
            label: 'Reason Description',
            field: 'reason_description',
            hidden:false,
            filterable: true,
            fpFieldType:"text",
        },
        {
            label: 'Original Invoice',
            field: 'original_invoice',
            fpFieldType:"text",
            hidden:false,
            // type:'number',
            filterable: false,
            sortable:false,
        },
        {
            label: 'Original Invoice Date',
            field: 'original_invoice_date',
            filterable: false,
            fpFieldType:"date",
            hidden:false,
            sortable:false,
        },
        {
            label: 'Original Invoice Src',
            field: 'original_invoice_source',
            hidden:false,
            filterable: false,
            fpFieldType:"text",
            sortable:false,
        },
        {
            label: 'Same Customer',
            field: 'same_customer',
            filterable: false,
            fpFieldType:"text",
            hidden:false,
            sortable:false,
        }
      ],
      batchProcess:0,
      batchNum:"",
  
  
  
  
    }),
    watch:{
      permissions: function(permission) {
          var self = this;
          permission.forEach(function (permissions) {
              if(permissions.name == 'net_billing_metrics_for_period') {
                  self.cantAccessPage = true;
              }
          });
          if(self.cantAccessPage == ''){
              self.cantAccessPage = false;
          }
      },
    },
    mounted: function(){
      var self = this;
      self.getPermissions();
    },
    methods:{
  
      // exportReports: function() {
      //             this.action = "export";
      //             this.loadList();
      //         },
  
      loadList: function(){
  
        var self = this;
        self.loading = true;
        var date = new Date();
        var offset = date.getTimezoneOffset();
        self.firstLoad = 1;
        $.ajax({
          url: process.env.ROOT_API + "/manual-billed-report/list",
          type: "POST",
          crossDomain: true,
          headers: this.ajxHeaders,
          dataType: "json",
          data: {
            page: self.serverParams.page,
            perPage: self.serverParams.perPage,
            filters: this.serverParams.columnFilters,
            sort: this.serverParams.sort,
            offset: offset,
            action:self.action
          },
          success: function(data) {
            self.loading = false;
            // console.log(data.content.row);
            if (data.status == "success") {
              if (self.action == "export" ||  self.action == "export_queue") {
                  if ( data.code == "201" ) {
                      alert(data.message);
                  } else {
                      if ( self.action == "export" ) {
  
                          self.excel = data.content.web;
                          var save = document.createElement("a");
                          save.href = self.excel;
                          save.download = data.content.web;
                          save.target = "_blank";
  
                          document.body.appendChild(save);
                          save.click();
                          document.body.removeChild(save);
                      } else {
  
                          self.batchProcess = 1;
                          self.batchNum = data.content;
                      }
                  }
  
                self.action = "list";
                // self.loadList();
            } else {
  
                console.log('success');
  
                if (data.content.row != undefined) {
  
                  console.log("data.content.log");
                  self.rows = data.content.row;
                }
  
                self.totalRecords = data.content.totalRecords;
  
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'net-billing-metrics-report');
        }
      });
  
  
      }
    }
  
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/reports/ManualBillingReport.vue